<template>
  <div :class="clContainer()">
    <span
      v-if="label && (!hideLabelState || state != hideLabelState)"
      :class="clSub('label', 'label')"
      >{{ label }}</span
    >
    <p :class="clSub('value', textClass)">{{ text }}</p>

    <vue-timepicker
      :id="id"
      :input-class="clSub('input', `form__input ${inputClass}`)"
      :placeholder="placeholder"
      :tabindex="tabindex"
      :hide-clear-button="true"
      :minute-interval="10"
      :close-on-complete="true"
      v-model="data"
      :disabled="disabledTime"
      manual-input
      @input="
        dataChanged(true);
        validate();
      "
      @focus="focused"
    >
    </vue-timepicker>

    <slot name="append" :state="state"></slot>

    <div :class="clSub('errors')">
      <div
        v-for="(error, index) in errors"
        :class="clSub('error')"
        :key="index"
      >
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script>
import Base from "./Base";
import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";

export default {
  extends: Base,
  components: { "vue-timepicker": VueTimepicker },
  props: {
    type: {
      type: String,
      default: "text",
    },
    typeClass: {
      type: String,
      default: "time",
    },
    ignoreUserChangeAfterSet: {
      type: Boolean,
      default: true,
    },
    disabledTime: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputClass: "",
    };
  },
  methods: {
    focused() {
      this.inputClass = "focused";
      this.validate();
    },
  },
};
</script>